function gradFab(hOE){
    //hOE=height_of_element
    let next=0,grad="",bloc=25,space=10;
    while(!(next>=hOE)){
        grad+=`,#0f1510ff ${what_(hOE,next)}%, #0f1510ff ${what_(hOE,next+=bloc)}%, rgba(0,0,0,0) ${what_(hOE,next)}%, rgba(0,0,0,0) ${what_(hOE,next+=space)}%`;
    }
    return grad
}

function what_(height,inc){
    return (100*inc)/(height)
}

function currentDuration(){
	let date=new Date();
	let date1=new Date()
	date=date.toString().split(" ")
	let time=date[4].split(":") 
	let dayt={dayw:date[0],month:date1.getMonth()+1,day:Number(date[2]),year:Number(date[3]),
		 hour:Number(time[0]),minute:Number(time[1]), second:Number(time[2]),tz:date[5]}
	return dayt
}

function datetimeDifference(param){
	let later=param,current=currentDuration(); 
	let dateObj={1:31, 2:28, 3:31, 4:30, 5:31, 6:30, 7:31, 8:31, 9:30, 10:31, 11:30, 12:31}
	let curMonth=current["month"],laterMonth=later["month"]
	let curYear=current["year"],laterYear=later["year"]
	let day,month,year; 
		//This block determines the day difference from the current day to the later day
	if(curYear===laterYear&&curMonth===laterMonth&&later["day"]>current["day"]){
		//This means that the year and month of both correspond and latter day is greater than 
		//the current day
		day=later["day"]-current["day"]
	}
	if(curYear===laterYear&&laterMonth>curMonth){
			//This implies that that both year corresponds and the later month goes after the current month
		day=dateObj[curMonth]-current["day"]
		month=curMonth;
		while(month<laterMonth){
			if((month+1)===laterMonth){
				day+=later["day"]; 
				month+=1
			}
			else{
				month+=1; 
				day+=dateObj[month];
			}
		}
	}
	if(laterYear>curYear){
			//This implies that the both year differs and the later year is greater than the current year 
		day=dateObj[curMonth]-current["day"]
		year=curYear; //let mon=curMonth
		while(year<laterYear){
			month=curMonth
			while(month<12){
				month+=1; 
				day+=dateObj[month]
				if(month===11){
					day+=dateObj[12]; month+=1; curMonth=0
				}
			}
			if((year+1)===laterYear){
				month=0
				while(month<laterMonth){
					if((month+1)===laterMonth){
						month+=1
						day+=later["day"]; 
					}	
					else{
						month+=1
						day+=dateObj[month];
					}
				}
			}
			curMonth=0
			year+=1
		}
	}
	if(curYear===laterYear&&curMonth===laterMonth&&later["day"]===current["day"]){
		day=0
	}
		//If the above conditions are not met, it means at least one of three things
		//a-In same month and year, the latter day is lesser than the former
		//b-In the same year the later month comes before the current month
		//c-The year of the current is greater than the former.
		//summary-All these inappropriaties conflicts the day span so the day will have a value of null
	if(curYear>laterYear){
		return "elapsed"
	}
	if(curYear===laterYear&&curMonth>laterMonth){
		return "elapsed"
	}
	if(curYear===laterYear&&curMonth===laterMonth&&current["day"]>later["day"]){
		return "elapsed"
	}
		//fixing the later and current in a portable array
	let latr=[day,later["hour"],later["minute"],later["second"]]
	let curt=[current["day"],current["hour"],current["minute"],current["second"]];
		// This adds the current day to the day difference for an accurate calculation
	latr[0]+=current["day"]; //console.log(curt);console.log(latr);
		//checking for inappropriaties
	let det=determiner(curt,latr);
	if(det[0]==="same"&&det[1]==="same"&&det[2]==="same"&&det[3]==="ab"){
		return "elapsed"
	}
	else if(det[0]==="same"&&det[1]==="same"&&det[2]==="ab"){
		return "elapsed"
	}
	else if(det[0]==="same"&&det[1]==="ab"){
		return "elapsed"
	}
	else if(det[0]==="ab"){
		return "elapsed"
	} 	
		//extracting the actual datetime difference
	let temp_sec,temp_min,temp_hour,temp_day
	if (det[2]!=="same"){
		temp_sec=(60-curt[3])+latr[3];
		temp_min=latr[2]-(curt[2]+1);
	}
	else if(det[2]==="same"){
		temp_sec=latr[3]-curt[3]
		temp_min=latr[2]-curt[2]
	}
	if (det[0]!=="same"){
		temp_hour=(24-curt[1])+latr[1]
		temp_day=latr[0]-(curt[0]+1)
	}
	else if(det[0]==="same"){
		temp_hour=latr[1]-curt[1]
		temp_day=latr[0]-curt[0]
	}
	let rest=[temp_day,temp_hour,temp_min,temp_sec]; //console.log(rest)
	let constant=[0,24,60,60]
		//Getting rid of all negative values
	for (let i=3; i>0; i--){ 
		if(i===0){
			break;
		}
		if(rest[i]<0){
			while(rest[i]<0){
				rest[i]+=constant[i]; rest[i-1]-=1
			}
		}
	} 
		//resolving values
	for (let i=3; i>0; i--){ 
		if(rest[i]>=constant[i]){
			while(rest[i]>=constant[i]){
				rest[i]-=constant[i]; rest[i-1]+=1
			}
		}
	}	
		//return value
	return {days:rest[0],hours:rest[1],minutes:rest[2],seconds:rest[3]}
}

function determiner(curt,latr){
    let arr=[]
	for(let i=0;i<4;++i){ 
		if(curt[i]===latr[i]){arr.push(`same`)} 
		else if(curt[i]>latr[i]){arr.push(`ab`)}
		else if(latr[i]>curt[i]){arr.push(`norm`)}
	};return arr
}

function attSwitch(elem,att){
	elem.setAttribute("id",`${att}`)
}

function slideLog(elem){
	elem.style.display="block"
	elem.style.top=`${document.documentElement.scrollTop+30}px`
	setTimeout(()=>{elem.style.top="-100px"},10000)
	setTimeout(()=>{
		elem.style.display="none"
	},12000)
}

function hAuto(parent,child){ 
	let auto=(parent.clientWidth/2)-(child.offsetWidth/2)+'px';
	child.style.left=auto;
}

// Convert Unix timestamp to date and time components
function timestampToDateTime(unixTimestamp) {
    const date = new Date(unixTimestamp * 1000); // Multiply by 1000 to convert seconds to milliseconds
    const year = date.getFullYear();
    const month = date.getMonth() + 1; // Months are zero-indexed
    const day = date.getDate();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();

    return {
        year: year,
        month: month,
        day: day,
        hour: hours,
        minute: minutes,
        second: seconds
    };
}



export {
	datetimeDifference, 
	gradFab, 
	currentDuration, 
	attSwitch, 
	slideLog, 
	timestampToDateTime, 
	hAuto,
} 